import axios from 'axios';
import React from 'react';

function Contact() {
  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const data = Object.fromEntries(formData.entries());
  
    try {
      const response = await axios.post('https://api.anab-co.com/send-email', data, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      
      console.log('Response from server:', response);
      
      if (response.status === 200) {
        alert('Email sent successfully!');
      } else {
        alert('Failed to send email.');
      }
    } catch (error) {
      console.error('Error sending email:', error);
      alert('Failed to send email.');
    }
  };

  return (
    <div className="contact py-5">
      <div className="d-flex flex-row flex-wrap justify-content-center align-items-center py-5">
        <div className="col-md-6 col-12 d-flex flex-column justify-content-center my-3 align-items-center">
          <h1 className="contact-title py-3">Contact Us</h1>
          <p className="w-75 paragraph">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Id quibusdam quis inventore repudiandae ipsum! Fugiat, minus! Quo et rem tenetur!
          </p>
        </div>
        <div className="col-md-6 col-12 d-flex flex-column justify-content-center my-3 align-items-center">
          <form className="w-75 d-flex flex-column" onSubmit={handleSubmit}>
            <input className="contact-input mt-3 rounded-4 form-control" name="name" type="text" placeholder="Name" required />
            <input className="contact-input mt-3 rounded-4 form-control" name="email" type="email" placeholder="Email Address" required />
            <input className="contact-input mt-3 rounded-4 form-control" name="company" type="text" placeholder="Company" />
            <input className="contact-input mt-3 rounded-4 form-control" name="phone" type="text" placeholder="Phone" />
            <textarea className="contact-input mt-3 rounded-4 form-control" name="message" rows={5} placeholder="How can we help you?" required />
            <button className="dark-btn ms-auto rounded-5 my-4" type="submit">Send</button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Contact;
